import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // Supported locales
  locales: ['sv', 'en'],
  
  // Default locale (Swedish as current)
  defaultLocale: 'sv'
});
